import React, { useMemo } from 'react';

// DEPENDENCIES
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { INVENTORY_SOURCE } from 'codes.js';
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { doCallback, formatDate, makePath } from 'functions.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// HELPERS
import { checkInventoryStatus } from '../../helpers/checkInventoryStatus';

// REACT ROUTER COMPONETNS
import { Link } from 'react-router-dom';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// VARIABLES
const CURRENT_DATE = new Date();

// MAIN COMPONENT
const ReturnSidebar = () => {
  
  // REACT ROUTER
  const { recordID } = useParams();

  // HOOKS
  const { record: {
    inventory_type,
    source_sales_id,
    source_name,
    stock_num,
    stock_num_return
  } = {}, refetchRecord } = useRecordContext() || {};

  // MEMOS
  const isTrade = useMemo(
    () => inventory_type === INVENTORY_SOURCE.trade.code,
    [inventory_type]
  )

  // RENDER
  return createPortal(
    <Sidebar name="returnSidebar" title="Return">
      <Sidebar.Form
        method="PUT"
        endpoint={ENDPOINTS.inventory.return}
        initialValues={{
          dailysalesinventoryid: recordID,
          dateReturned: formatDate(CURRENT_DATE)
        }}
        loadingMessage={`Returning stock # ${stock_num}`}
        successMessage={`Stock # ${stock_num} has been successfully returned`}
        errorMessage={`Failed to return stock # ${stock_num}`}
        onSuccess={() => {
          doCallback(refetchRecord);
        }}
        buttons={{
          submit: {
            show: !isTrade
          }
        }}
      >
        {isTrade ? (
          <Form.Text>
            <big>
              In order to return this vehicle, you will need to delete the trade from deal for:
              &nbsp;
              <Link to={makePath(INTERFACE.sales, RECORD.view, source_sales_id)}>{`(${source_name}, Stock#: ${stock_num_return})`}</Link>
            </big>
          </Form.Text>
        ) : [
          <Form.Text>
            <big>You are returning the vehicle to the original source and this vehicle will be removed from the inventory. Please provide the reason for return under comments.</big>
          </Form.Text>,
          <Form.Date name="dateReturned" label="Date Returned" maxDate={CURRENT_DATE} required />,
          <Form.Textarea name="returnedComment" label="Comments" required />
        ]}
      </Sidebar.Form>
    </Sidebar>,
    document.body
  );
};
const ReturnSidebarButton = () => (
  <Sidebar.Button
    name="returnSidebar"
    label="Return"
    icon="cancel"
    outline
    fullWidth={false}
    size="sm"
/>
)
ReturnSidebar.Button = checkInventoryStatus(ReturnSidebarButton, [ 'preStock', 'inStock', 'fallout', 'backout']);

// EXPORT
export default ReturnSidebar;
